module.exports = __webpack_public_path__ + "media/T.43eb8fc4.mp3";